export { default as LabList } from "./labList";
